/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DisclaimerItemDto,
  SmartProblemDetails,
} from '../models/index';
import {
    DisclaimerItemDtoFromJSON,
    DisclaimerItemDtoToJSON,
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
} from '../models/index';

export interface DisclaimerGetRequest {
    type?: string;
    language?: string;
}

export interface DisclaimerGetAllRequest {
    type?: string;
}

export interface DisclaimerPutRequest {
    disclaimerItemDto?: DisclaimerItemDto;
}

export interface DisclaimerPutBulkRequest {
    disclaimerItemDto?: Array<DisclaimerItemDto>;
}

/**
 * 
 */
export class DisclaimerApi extends runtime.BaseAPI {

    /**
     */
    async disclaimerGetRaw(requestParameters: DisclaimerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DisclaimerItemDto>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Disclaimer`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DisclaimerItemDtoFromJSON(jsonValue));
    }

    /**
     */
    async disclaimerGet(requestParameters: DisclaimerGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DisclaimerItemDto> {
        const response = await this.disclaimerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async disclaimerGetAllRaw(requestParameters: DisclaimerGetAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DisclaimerItemDto>>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Disclaimer/all`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DisclaimerItemDtoFromJSON));
    }

    /**
     */
    async disclaimerGetAll(requestParameters: DisclaimerGetAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DisclaimerItemDto>> {
        const response = await this.disclaimerGetAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async disclaimerPutRaw(requestParameters: DisclaimerPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DisclaimerItemDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Disclaimer`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DisclaimerItemDtoToJSON(requestParameters['disclaimerItemDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DisclaimerItemDtoFromJSON(jsonValue));
    }

    /**
     */
    async disclaimerPut(requestParameters: DisclaimerPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DisclaimerItemDto> {
        const response = await this.disclaimerPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async disclaimerPutBulkRaw(requestParameters: DisclaimerPutBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DisclaimerItemDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Disclaimer/bulk`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['disclaimerItemDto']!.map(DisclaimerItemDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DisclaimerItemDtoFromJSON));
    }

    /**
     */
    async disclaimerPutBulk(requestParameters: DisclaimerPutBulkRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DisclaimerItemDto>> {
        const response = await this.disclaimerPutBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
